export const ADD_TRACKER_ATTRIBUTE_REQUEST = 'ADD_TRACKER_ATTRIBUTE_REQUEST';
export const ADD_TRACKER_ATTRIBUTE_SUCCESS = 'ADD_TRACKER_ATTRIBUTE_SUCCESS';
export const ADD_TRACKER_ATTRIBUTE_ERROR = 'ADD_TRACKER_ATTRIBUTE_ERROR';
export const UPDATE_TRACKER_ATTRIBUTE_REQUEST =
  'UPDATE_TRACKER_ATTRIBUTE_REQUEST';
export const UPDATE_TRACKER_ATTRIBUTE_SUCCESS =
  'UPDATE_TRACKER_ATTRIBUTE_SUCCESS';
export const UPDATE_TRACKER_ATTRIBUTE_ERROR = 'UPDATE_TRACKER_ATTRIBUTE_ERROR';
